export default __webpack_public_path__ + "static/15-9f369932750e33722b626d579a2e6f9f.jpg";